import { combineReducers } from "redux";

// Reducers
import Cart from "./cart_reducer";
import Login from "./login_reducer";
import Services from "./service_reducer";
import Checkout from "./checkout_reducer";
import Category from "./category_reducer";
import Popup from "./popup_reducer";
import Attributes from "./attribute_reducer";
import Notification from "./notification";
import Address from "./address_reducer";
import Otp from "./otp_reducer";
import Region from "./region_reducer";

const Reducers = combineReducers({
  Cart,
  Login,
  Services,
  Checkout,
  Category,
  Popup,
  Attributes,
  Notification,
  Address,
  Otp,
  Region,
});
export default Reducers;
